<template>
  <b-badge
      variant="primary"
      pill
      :style="{ background: bgColor }"
  >
    {{ count }}
  </b-badge>
</template>

<script>
export default {
  name: 'Status-Counter',
  props: {
    count: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      required: true
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
};
</script>
